<template>
  <div class="following-page">
    <van-nav-bar
      title="我的关注"
      left-arrow fixed
      @click-left="$router.back()"
    />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="— 没有更多了 —"
        @load="onLoad"
      >
        <div
          v-for="item in list" :key="item.bloggerId"
          class="follow-card"
          @click="$router.push('/blogger/' + item.bloggerId)"
        >
          <div class="f-avatar">
            <img v-if="item.avatarUrl" :src="item.avatarUrl" alt="" />
            <van-icon v-else name="user-o" size="26" color="#a5b4fc" />
          </div>
          <div class="f-info">
            <div class="f-name">{{ item.nickname || item.username }}</div>
            <div class="f-bio" v-if="item.bio">{{ item.bio }}</div>
            <div class="f-bio f-bio-empty" v-else>暂无简介</div>
          </div>
          <van-icon name="arrow" size="16" color="#d1d5db" />
        </div>
      </van-list>
    </van-pull-refresh>

    <van-empty
      v-if="!loading && list.length === 0"
      image="search"
      description="你还没有关注任何博主"
    />
  </div>
</template>

<script>
import { followApi } from '../api';

export default {
  data() {
    return {
      list: [], page: 1, size: 20,
      loading: false, finished: false, refreshing: false
    };
  },
  methods: {
    async onLoad() {
      const res = await followApi.myFollowings({ page: this.page, size: this.size });
      const data = res.data;
      this.list = this.page === 1 ? data.list : [...this.list, ...data.list];
      this.loading = false;
      if (this.list.length >= data.total) this.finished = true;
      this.page++;
    },
    async onRefresh() {
      this.page = 1; this.finished = false;
      this.loading = true;
      await this.onLoad();
      this.refreshing = false;
    }
  }
};
</script>

<style scoped>
.following-page {
  min-height: 100vh; background: #f5f7fa; padding-top: 46px;
}
.follow-card {
  display: flex; align-items: center; gap: 14px;
  margin: 8px 16px; padding: 16px;
  background: #fff; border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  cursor: pointer;
}
.f-avatar {
  width: 52px; height: 52px; border-radius: 50%;
  background: #eef2ff; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.f-avatar img {
  width: 100%; height: 100%; object-fit: cover;
}
.f-info {
  flex: 1; min-width: 0;
}
.f-name {
  font-size: 16px; font-weight: 600; color: #1f2937;
}
.f-bio {
  font-size: 13px; color: #9ca3af; margin-top: 4px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.f-bio-empty {
  font-style: italic; color: #d1d5db;
}
</style>
